import { render } from "./FpSteps.vue?vue&type=template&id=40c8b9c4"
import script from "./FpSteps.vue?vue&type=script&lang=js"
export * from "./FpSteps.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__